import { ProblemDetails } from "../models/Http";
import { Category } from "../models/Product";
import { get, put, post, upload, del } from "./api";
import { Result, err, ok } from "../result";

export const getProductCategories = async (): Promise<
  Result<ProblemDetails, Category[]>
> => {
  const response = await get("/v1/product-category");
  const content = await response.json();

  if (response.ok) {
    return ok(content as Category[]);
  }

  return err(content as ProblemDetails);
};

export const addCategory = async (
  model: Category
): Promise<Result<ProblemDetails, Category>> => {
  const response = await post("/v1/product-category", model);
  const content = await response.json();

  if (response.ok) {
    return ok(content as Category);
  }

  return err(content as ProblemDetails);
};

export const updateCategory = async (
  model: Category
): Promise<Result<ProblemDetails, Category>> => {
  const response = await put(`/v1/product-category/${model.id}`, model);
  const content = await response.json();

  if (response.ok) {
    return ok(content as Category);
  }

  return err(content as ProblemDetails);
};

export const updateCategoryOrder = async (
  categories: Category[]
): Promise<Result<ProblemDetails, any>> => {
  const response = await put(`/v1/product-category/re-order`, categories);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};

export const deleteCategory = async (
  model: Category,
  deleteProducts: boolean,
  moveToCategoryId: string
): Promise<Result<ProblemDetails, any>> => {
  const response = await del(`/v1/product-category/${model.id}`, {
    deleteProducts,
    moveToCategoryId
  });

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};

export const uploadImage = async (
  id: string,
  image: Blob
): Promise<Result<ProblemDetails, any>> => {
  const response = await upload(
    `/v1/product-category/${id}/image`,
    image,
    "categoryImage"
  );

  if (response.ok) {
    return ok({});
  }
  const content = await response.json();

  return err(content as ProblemDetails);
};
